import { alpha, Box, Divider, Stack } from '@mui/material';
import React from 'react';

import { MobileBody, MobileCaption } from '../Typography';

export interface KeyValueRowItem {
  label: string;
  value: string;
}

export interface KeyValueCardProps {
  /** Filas a mostrar: etiqueta (izq) y valor (der). */
  items: KeyValueRowItem[];
  /** Si es true, la última fila usa tipografía destacada (bold + color primary). */
  highlightLastRow?: boolean;
  sx?: object;
}

const KeyValueCard: React.FC<KeyValueCardProps> = ({
  items,
  highlightLastRow = false,
  sx,
}) => {
  if (items.length === 0) return null;

  const normalItems = highlightLastRow ? items.slice(0, -1) : items;
  const lastItem = highlightLastRow ? items[items.length - 1] : null;

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1.25,
        ...sx,
      }}
    >
      <Stack spacing={1}>
        {normalItems.map((row, index) => (
          <Box
            key={`${row.label}-${index}`}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 1,
              minWidth: 0,
            }}
          >
            <MobileCaption
              component="span"
              sx={{
                color: 'text.secondary',
                fontSize: '0.75rem',
                fontWeight: 400,
                flex: '1 1 auto',
                minWidth: 0,
              }}
            >
              {row.label}
            </MobileCaption>
            <MobileCaption
              component="span"
              sx={{
                color: 'text.primary',
                fontSize: '0.75rem',
                fontWeight: 600,
                flexShrink: 0,
              }}
            >
              {row.value}
            </MobileCaption>
          </Box>
        ))}
        {lastItem != null && (
          <>
            <Divider sx={{ my: 0.5 }} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1,
                minWidth: 0,
              }}
            >
              <MobileBody
                component="span"
                sx={{
                  color: 'text.primary',
                  fontSize: '1rem',
                  fontWeight: 600,
                  flex: '1 1 auto',
                  minWidth: 0,
                }}
              >
                {lastItem.label}
              </MobileBody>
              <MobileBody
                component="span"
                sx={{
                  color: 'primary.main',
                  fontSize: '1rem',
                  fontWeight: 700,
                  flexShrink: 0,
                }}
              >
                {lastItem.value}
              </MobileBody>
            </Box>
          </>
        )}
      </Stack>
    </Box>
  );
};

export default KeyValueCard;
